import { render } from "./SearchSelect.vue?vue&type=template&id=72ff2e28"
import script from "./SearchSelect.vue?vue&type=script&lang=js"
export * from "./SearchSelect.vue?vue&type=script&lang=js"

import "./SearchSelect.vue?vue&type=style&index=0&id=72ff2e28&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__